module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-petition"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "wwf-loading-container"
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('header', {
    staticClass: "header-container"
  }, [_c('DynamicHeader', {
    attrs: {
      "content": _vm.headerContent
    }
  })], 1), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "petition-container"
  }, [_c('section', {
    staticClass: "form-section"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "form-wrapper"
  }, [_c('PetitionBio', {
    attrs: {
      "datalayerName": _vm.datalayerName,
      "programName": _vm.programName,
      "counterLimit": _vm.counterLimit,
      "counterTitle": _vm.counterTitle,
      "signButtonValue": _vm.signButtonValue,
      "viewMessageButtonValue": _vm.viewMessageButtonValue,
      "viewMessagePosition": _vm.viewMessagePosition,
      "letterTitle": _vm.letterTitle,
      "letterMessage": _vm.letterMessage,
      "stepupId": _vm.stepupId,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "content-section"
  }, [_c('DynamicContent', {
    attrs: {
      "content": _vm.mainContent
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-loading"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ff9704f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/dynamic-petition/DynamicPetition.vue
// module id = 779
// module chunks = 0